import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetPredefinedResponsesActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetPredefinedResponsesActivityResponseDataSchema>>

type Props = {
  campaignId?: string
  goalId: string
}

export const PredefinedResponsesActivityQuery = ({ campaignId, goalId }: Props) => {
  return queryOptions({
    queryKey: ["responsesActivity", campaignId, goalId],
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/activity/predefined-responses`, {
        params: { campaignId, goalId },
      })
      return response.data.data
    },
  })
}
